"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoPaymentDetailsPanelCms = void 0;
var AutoPaymentDetailsPanelCms = /** @class */ (function () {
    function AutoPaymentDetailsPanelCms() {
        this.sectionTitleLabel = 'AutoPay';
        this.sectionDescriptionLabel = "AutoPay is a free and convenient service. It lets\n     you pay your monthly bill automatically, securely, and on time.";
        this.savingsOfferDiscountLabel = "Get a $5 discount off your bill for 12 months when\n     you monthly bill automatically, securely, and on time.";
        this.autopayConsentLabel = 'Want to sign up for AutoPay?';
        this.signUpCheckboxLabel = 'Yes, sign me up for AutoPay';
        this.noThanksRadioLabel = 'No, thanks';
        this.noThanksDesciptionCombinationLabelOne = "Don't miss out! Sign up today, or you won't qualify for the $";
        this.noThanksDesciptionCombinationLabelTwo = "/mo. discount.";
        this.autopayCheckedLabelOne = "Sign up and save $";
        this.autopayCheckedLabelTwo = "/mo.";
        this.autoPayTermsLinkLabel = 'Read the [[paymentTerm]] Terms & Conditions';
        this.autoPayPrepaidTermsLinkLabel = "Read the AT&T PREPAID AutoPay Terms & Conditions";
        this.autoPayTermsConsentLabel = "I have read and agree to the [[paymentTerm]] Terms & Conditions. <strong>I\n     understand AutoPay will continue automatically until I cancel it at att.com/myatt.</strong>";
        this.autoPayPrepaidTermsConsentLabel = "I have read and agree to the AT&T PREPAID AutoPay Terms & Conditions.";
        this.autoPayFromDuetodayLabel = 'Use payment method';
        this.autoPayExternalContentLinkUrl = 'https://www.att.com/legal/terms.iframes.autoPayAndStorage.html';
        this.prepaidAutoPayExternalContentLinkUrl = "/legal/terms.iframes.prepaidAutoPayTerms.html";
        this.editLinkAriaLabel = 'Edit Auto payment Info';
        this.editLinkCTALabel = 'Edit';
        this.multiLineAutopayLabel = 'Choose which lines to sign up for AutoPay';
        this.multiLineCheckboxLabel = 'Line [[X]] : [[PLAN]] plan';
    }
    return AutoPaymentDetailsPanelCms;
}());
exports.AutoPaymentDetailsPanelCms = AutoPaymentDetailsPanelCms;
//# sourceMappingURL=AutoPaymentDetailsPanelCms.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/AutoPaymentDetailsPanel/AutoPaymentDetailsPanelCms.cms.js
// module id = 2036
// module chunks = 8